__turbopack_context__.v({
  "root": "TabsWithCards-module-scss-module__7FbLGW__root",
});
